import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import React from 'react';
import {useWorkspaceContext} from '../../../context/workspaceContext';
import PsfTemplateService from '../../../services/psf-template.service';
import PsfTemplate from '../../../@types/psfTemplate';
import {ResourceType} from '../../../@types/resource-type';
import {toast} from 'react-toastify';
import DotdotdotButton from '../../form-components/DotdotdotButton.component';
import DeleteResource from '../modals/DeleteResource.component';
import Box from '@mui/material/Box';
import DuplicateResource from '../modals/DuplicateResource.component';
import {filterOnGroupCanEdit} from '../../../utils/resource-utils';

export default function PsfTemplateActionsMenu(props: {
    psfTemplate: PsfTemplate
}): React.ReactElement {
    const [confirmDeletePsfTemplate, setConfirmDeletePsfTemplate] = React.useState<boolean>(false);
    const [confirmDuplicatePsfTemplate, setConfirmDuplicatePsfTemplate] = React.useState<boolean>(false);

    const { setCurrentWorkspaceObject,
        setDeletedWorkspaceObject,
        setWorkspaceObjects, workspaceObjects, getAdditionalResource } = useWorkspaceContext();
    const { psfTemplate } = props;
 
    function onProperties(): void {
        setCurrentWorkspaceObject({ objectType: ResourceType.PERFORMANCE_SHAPING_FACTORS, object: psfTemplate });
    }

    function onDelete(): void {
        setConfirmDeletePsfTemplate(true);
    }

    function onDuplicate(): void {
        setConfirmDuplicatePsfTemplate(true);
    }

    return (
        <Box tabIndex={0}  onClick={(event: any): void => {
            event.stopPropagation();
        }}>
            <DotdotdotButton>
                <MenuItem id='properties' onClick={onProperties}>Properties</MenuItem>
                <MenuItem id='duplicate' onClick={onDuplicate}>Duplicate</MenuItem>
                {
                    psfTemplate.group.canEdit() && <Divider /> && <MenuItem id='delete' onClick={onDelete}>Delete</MenuItem>
                }
            </DotdotdotButton>
            <DeleteResource
                open={confirmDeletePsfTemplate}
                resourceType={ResourceType.PERFORMANCE_SHAPING_FACTORS}
                resourceName={psfTemplate.name}
                subResources={'performance shaping factor presences associated with it'}
                handleDelete={(): void => {
                    PsfTemplateService.deletePsfTemplateById(psfTemplate.id!).then(() => {
                        setDeletedWorkspaceObject({
                            objectType: ResourceType.PERFORMANCE_SHAPING_FACTORS,
                            id: psfTemplate.id!
                        });
                        setWorkspaceObjects({ objectType: workspaceObjects?.objectType ?? ResourceType.GROUPS });
                    }).catch((error) => {
                        toast.error(error.message);
                    }).finally(() => {
                        setConfirmDeletePsfTemplate(false);
                    });

                }}
                onClose={(): void => {
                    setConfirmDeletePsfTemplate(false);
                }}
            />
            <DuplicateResource
                open={confirmDuplicatePsfTemplate}
                title={'Duplicate PSF Template - ' + psfTemplate.name}
                onClose={(): void => { setConfirmDuplicatePsfTemplate(false); }}
                onConfirm={
                    (id: number): void => {
                        let targetGroupId = id > 0 ? id : undefined;
                        let sourcePsfTemplateId = psfTemplate.id;
                        setConfirmDuplicatePsfTemplate(false);
                        PsfTemplateService.duplicatePsfTemplate(sourcePsfTemplateId!, targetGroupId).then((response) => {
                            setWorkspaceObjects({ objectType: ResourceType.PERFORMANCE_SHAPING_FACTORS });
                            toast.info(response.data.name + ' duplicated successfully');
                        }).catch((error) => {
                            toast.error(error.message);
                        });
                    }
                }
                object={{objectType: ResourceType.PERFORMANCE_SHAPING_FACTORS, object: psfTemplate}}
                data={filterOnGroupCanEdit(getAdditionalResource(ResourceType.GROUPS))}
            />
        </Box>
    );
}
